/**
 * This function will dynamically submit any
 * form with the class wordpress-ajax-form.
 * Then perform a trigger `submit-callback`
 * with the returned data.
 */

// on submit
$('.wordpress-ajax-form').on('submit', function(event) {
	event.preventDefault();
	const form = $(event.currentTarget);
	const callout = $(this).children('.callout');

	// Reset callout
	if (callout.length) {
		callout.addClass('hide').removeClass(['success', 'alert']);
    }

	// Call admin-ajax.php
	$.ajax({
		method: 'POST',
		url: form.attr('action'),
		data: form.serialize(),
		dataType: 'json',
	})
		.done(data => {
			// Call callback event
			form.trigger('submit-callback', data);
		})
		.fail(error => {
			form.trigger('submit-callback', {
				error: true,
				message: 'Er is iets mis gegaan, probeer het later opnieuw.',
			});
		});
});
